export default "__VITE_ASSET__DmgOhzZc__"